export default function createAPIAction(context, payload, done) {
    context.dispatch('USER_APIS_ADDED', payload);
    done();
}
